export interface IBreakpoints {
  mobile: string;
  tablet: string;
  desktop: string;
  highresDesktop: string;
}

const breakpoints: IBreakpoints = {
  mobile: '576px',
  tablet: '991.9px',
  desktop: '992px',
  highresDesktop: '1400px',
};

export default breakpoints;
